import axiosInstance from './axiosConfig'
import { createCancelToken } from './axiosUtils'

const FieldDataAPI = {
  getSubmissionField: function ({ org_id, folder_id, submission_id  }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/field-data`,
    })
  },
  getById: function ({ org_id, folder_id, submission_id, field_data_id   }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/field-data/${field_data_id}`,
    })
  },
  addFieldRow: function ({ org_id, folder_id, submission_id, parent }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/add-field-data`,
      data: { parent },
    })
  },
  addFieldColumn: function ({  org_id, folder_id, submission_id, parent }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/add-field-data-column`,
      data: { parent },
    })
  },
  deleteFieldRow: function ({org_id, folder_id, submission_id, field_data_id }) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/field-data/${field_data_id}`,
    })
  },
  deleteFieldColumn: function ({org_id, folder_id, submission_id, parent, position }) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/delete-field-data-column`,
      data: { parent, position },
    })
  },
  update: function ({org_id, folder_id, submission_id, field_data_id, value, datapoint_id }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/submissions/${org_id}/${folder_id}/${submission_id}/field-data/${field_data_id}`,
      data: { value, data: datapoint_id },
      cancelToken: cancelTokenObject[this.update.name].requestCancellation().token,
    })
  },
}

const cancelTokenObject = createCancelToken(FieldDataAPI)
export default FieldDataAPI
